/**
 * Equalize Post-Thumbnails (Aspect-Ratio 1:1) for Safari Browsers to Equal Height which is 100% of their current width.
 * Performance: Batched read/write operations to prevent layout thrashing
 */

function equalizePostThumbnails() {
  const list = document.querySelectorAll('.archive-grid article.media-container, #archiveWrapper .vz-jobs-list li.job-item');

  if (list.length === 0) {
    return;
  }

  // Phase 1: Read all dimensions (batch read to prevent layout thrashing)
  const measurements = [];
  list.forEach(function(item) {
    const imageContainer = item.querySelector('.post-thumbnail');
    if (imageContainer) {
      measurements.push({
        element: imageContainer,
        width: imageContainer.offsetWidth
      });
    }
  });

  // Phase 2: Write all styles (batch write)
  requestAnimationFrame(() => {
    measurements.forEach(function(measurement) {
      measurement.element.style.removeProperty("height");
      measurement.element.style.height = `${measurement.width}px`;
    });
  });
}

/**
 * Event delegation for AJAX filter buttons
 * Uses single delegated handler instead of N individual handlers
 */
function ajaxButtonEqualize() {
  // Early exit if not on archive page
  if (!document.body.classList.contains('archive')) {
    return;
  }

  // Event delegation on shared parent containers
  const formatSelection = document.getElementById('media-format-selection');
  const categoryFilter = document.getElementById('media-category-filter');

  if (formatSelection) {
    formatSelection.addEventListener('click', event => {
      if (event.target.matches('button')) {
        setTimeout(equalizePostThumbnails, 1000);
      }
    });
  }

  if (categoryFilter) {
    categoryFilter.addEventListener('click', event => {
      if (event.target.matches('li.js-category-button')) {
        setTimeout(equalizePostThumbnails, 1000);
      }
    });
  }
}
